<div class="vtr-widget-device-update">
	<div class="container-fluid">
		<div class="row">
			<div class="col col-12 systemupdate-background">
				<div *ngIf="!showProgress && !isUpdateDownloading && !isInstallationCompleted">
					<div *ngIf="!isUpdatesAvailable; else updatesAvailable">
						<div class="row">
							<div class="col title"
								id="system-update-title"
								role="heading">{{title}}</div>
						</div>
						<div class="row">
							<div class="col subtitle"
								id="system-update-sub-title1"
								role="text">{{subTitle1}}</div>
						</div>
						<div class="row">
							<div class="col subtitle"
								id="system-update-sub-title2"
								role="text">{{subTitle2}}</div>
						</div>
						<div class="row">
							<div class="button-row">
								<vtr-material-button linkId="su_check_updates"
									[heightSize]="'lg'"
									[isDisabled]="isCheckingPluginStatus"
									[label]="buttonText"
									(buttonClick)="onCheckForUpdates()">
								</vtr-material-button>
							</div>
						</div>
					</div>
					<ng-template #updatesAvailable>
						<div class="row">
							<div class="col">
								<div class="title" id="su_availableUpdates" role="text">{{'systemUpdates.availableUpdates.title' | translate}}</div>
							</div>
						</div>
						<div class="row no-gutters">
							<div class="col-sm-12 col-md-12">
								<div class="subtitle" id="su_availableUpdates_desc" role="text">{{'systemUpdates.availableUpdates.description' | translate}}</div>
							</div>
						</div>
						<div class="inline-buttons">
							<vtr-material-button class="inline-button"
								(buttonClick)="onUpdateNow($event)"
								[heightSize]="'lg'"
								[linkId]="'su_install_selected_updates'"
								[isDisabled]="(!isUpdateSelected || isButtonUpdateNowClicked)"
								[label]="'systemUpdates.availableUpdates.installSelectedUpdates' | translate">
							</vtr-material-button>
							<button
								mat-customize-button
								class="link-button ml-4"
								type="button"
								id="su_available_updates_check_again"
								(click)="onCheckForUpdates()"
								[matTooltip]="'systemUpdates.banner.checkAgain' | translate"
								matTooltipClass="vtr-system-tooltip"
								>{{'systemUpdates.banner.checkAgain' | translate | uppercase}}
							</button>
						</div>
					</ng-template>
				</div>
				<div *ngIf="isInstallationCompleted">
					<div *ngIf="isInstallationSuccess;else installFailed">
						<div class="row">
							<div class="col">
								<div class="title" id="su_installSuccessHeader" role="text">{{'systemUpdates.availableUpdates.installSuccessHeader' | translate}}</div>
								<div class="subtitle" id="system-update-sub-title1" role="text">{{subTitle1}}</div>
								<div class="subtitle" id="system-update-sub-title2" role="text">{{subTitle2}}</div>
							</div>
						</div>
					</div>
					<ng-template #installFailed>
						<div class="row">
							<div class="col">
								<div class="title" id="su_installFailHeader" role="text">{{'systemUpdates.availableUpdates.installFailHeader' | translate}}</div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<div class="subtitle" id="su_installFailDescription" role="text">{{'systemUpdates.availableUpdates.installFailDescription' | translate}}</div>
							</div>
						</div>
					</ng-template>
					<div class="inline-buttons">
						<vtr-material-button
							class="inline-button"
							(buttonClick)="onCheckForUpdates()"
							[heightSize]="'lg'"
							[linkId]="'su_install_complete_check_again'"
							[label]="'systemUpdates.banner.checkAgain' | translate | uppercase">
						</vtr-material-button>
					</div>
				</div>
				<div *ngIf="showProgress"
					class="col row">
					<div class="col col-12 progress-div">
						<div class="progress-title"
							id="su-cheking-updates-title"
							role="text">{{'systemUpdates.banner.checking' | translate}}</div>
						<div class="progress-percent-text" [dir]="'dir'|translate">
							<span class="progress-value-text" id="su-progress-check-value" role="text">{{percent}}</span>
							<span class="progress-complete-text">%&nbsp;{{'systemUpdates.banner.percent' | translate}}</span>
						</div>
					</div>
					<div class="col col-12 row progress-bar-div-container">
						<div class="col col-12"
						id="su_check_progress"
						role="progressbar">
							<mat-progress-bar mode="determinate" [value]="percent">
							</mat-progress-bar>
						</div>
					</div>
					<div class="col col-12 row">
						<div class="col col-12 cancel-check">
							<button
								mat-customize-button
								class="link-button"
								type="button"
								id="su_cancel_updates"
								[disabled]="percent === 0 || isCheckingStatus || isCancelingStatus"
								(click)="cancelUpdates()">
								{{'systemUpdates.banner.cancelCheck' | translate | uppercase}}
							</button>
						</div>
					</div>
				</div>
				<div *ngIf="isUpdateDownloading" class="col row">
					<div class="col col-12 progress-div">
						<div *ngIf="installingPercent === 0" class="col col-9 progress-title" id="su-progress-download-title" role="heading">
							{{downloadingUpdateText}}
						</div>
						<div *ngIf="installingPercent > 0" class="col col-9 progress-title" id="su-progress-install-title" role="heading">
							{{'systemUpdates.banner.installing' | translate}}
						</div>
						<div class="progress-subtitle" id="su-progress-subtitle" role="text">{{installingTitleText}}</div>
						<div class="progress-percent-text">
							<span *ngIf="installingPercent === 0" class="progress-value-text" id="su-progress-download-value" role="text">{{downloadingPercent}}</span>
							<span *ngIf="installingPercent > 0" class="progress-value-text" id="su-progress-install-value" role="text">{{installingPercent}}</span>
							<span class="progress-complete-text">%&nbsp;{{'systemUpdates.banner.percent' | translate}}</span>
						</div>
					</div>
					<div class="col col-12 row progress-bar-div-container">
						<div class="col col-12" *ngIf="installingPercent === 0" id="su_download_progress" role="progressbar">

							<mat-progress-bar mode="determinate" [value]="downloadingPercent">
							</mat-progress-bar>

						</div>
						<div class="col col-12" *ngIf="installingPercent > 0" id="su_install_progress" role="progressbar">

							<mat-progress-bar mode="determinate" [value]="installingPercent">
							</mat-progress-bar>
						</div>
					</div>

					<div class="col col-12 row">
						<div class="col col-12 cancel-check">
							<button
								mat-customize-button
								class="link-button"
								type="button"
								id="su_cancel_update_download"
								[title]=""
								[disabled]="downloadingPercent === 100 || downloadingPercent === 0"
								(click)="onCancelUpdateDownload()"
								[matTooltip]="'systemUpdates.popup.cancelButton' | translate"
								matTooltipClass="vtr-system-tooltip" >
								{{'systemUpdates.popup.cancelButton' | translate | uppercase}}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
